import React, { Component } from 'react'
import moment from 'moment';
import axios from 'axios';
import '../style/schedule.scss'

export default class Schedule extends Component {

    constructor(props) {
        super(props);
        this.state = {
            schedule : '',
            loaded: false,
            timeList: ["05:00:00","06:00:00","08:00:00","09:00:00","10:00:00","10:15:00","12:00:00","16:00:00","17:30:00","19:00:00"],
            times: ["5.00","6.00","8.00","9.00","10.00","10.15","12.00","16.00","17.30","19.00"]
        };
    }


    componentDidMount(){
        let curr = new Date; // get current date
        let first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
        let firstday = new Date(curr.setDate(first));
        let dateString = firstday.getFullYear() + '-' + (firstday.getMonth() + 1) + '-' + parseInt(firstday.getDate());
        let now = moment(dateString);
        now = now.add(1,"days");
        let dateArray=[]

        for(let i=0;i<7;i++){
            dateArray.push(now.format('L'));
            now = now.add(1,"days");

        }

        let promises = [];
        let mainObject = {};

        dateArray.forEach(function(date){
            promises.push(axios.get('https://app.wodify.com/API/Classes_v1.aspx', {
                params: {
                    apiKey: 'vtaR6x7gTaDT21oOgt4LDsHbd',
                    date: date,
                    type: 'JSON'
                }
            })
            )
          });
          
        function dayOfWeek(day) {
            let week = ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"];
            return week[day];
        }

          let self = this;
          axios.all(promises).then(function(results) {
            results.forEach(function(response) {
                let timestamp = new Date(response.data.RecordList.Class[0].StartDate);
                let day = dayOfWeek(timestamp.getDay());
                mainObject[day] = response.data.RecordList.Class;
            })
            self.setState({schedule: mainObject, loaded: true})
            
        });

        
            
        }
    
    
    render() {
        console.log(this.state.schedule);
        if(!this.state.loaded){
            return <h1>Loading</h1>
        }
        else{return (
        <>
        {/* Schedule  */}
        <section id="schedule" className="py-5">
            <div className="container">
                <h1 className="teko schedule_title mt-5 mb-2">CLASS <br/> SCHEDULE</h1>
                <div className="decorative-line"></div>
                <h1 className="schedule_text teko">SCHEDULE</h1>
            </div>
            
            {/* <!-- Schedule Table --> */}
            <table className="mx-auto py-5">
                    <thead id="#thead">
                        <tr>
                            <th></th>
                            <th>MONDAY</th>
                            <th>TUESDAY</th>
                            <th>WEDNESDAY</th>
                            <th>THURSDAY</th>
                            <th>FRIDAY</th>
                            <th>SATURDAY</th>
                            <th>SUNDAY</th>
                        </tr>
                        {this.state.times.map((time,index) => {
                            return( <tr key={time}>
                                {["time","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"].map(x => {
                                    if(x === "time"){
                                        return <th><h3 className="time">{time}</h3></th>
                                    }else{
                                        for(let i=0; i<this.state.schedule[x].length; i++){
                                            if(this.state.schedule[x][i].StartTime === this.state.timeList[index]){
                                                let current = this.state.schedule[x][i];
                                                let coach = "";
                                                let endtime = "";
                                                endtime = new Date(current.EndDateTime)
                                                endtime = endtime.getHours() +"."+ endtime.getMinutes();
                                                if(endtime.length <= 4){
                                                    endtime += "0";
                                                }
                                                if(!current.Coaches){
                                                    coach = ""
                                                    }
                                                    else{
                                                    coach = current.Coaches.APICoach.Name
                                                }
                                            
                                                if(current.ProgramName == "CrossFit"){
                                                    return(<td>
                                                        <h3 className='crossfit'>CrossFit</h3>
                                                        <h4 className='time'>{time} - {endtime} </h4>
                                                        <h4 className='coach'>{coach}</h4>
                                                        </td>)        
                                                }        
                                                else if(current.ProgramName == "OUTLAST"){
                                                    return(<td>
                                                        <h3 className='outlast'>OUTLAST</h3>
                                                        <h4 className='time'>{time} - {endtime} </h4>
                                                        <h4 className='coach'>{coach}</h4>
                                                        </td>)        
                                                }        
                                                else if(current.ProgramName == "Open Gym"){
                                                    return(<td>
                                                        <h3 className='opengym'>OPEN GYM</h3>
                                                        <h4 className='time'>{time} - {endtime} </h4>
                                                        <h4 className='coach'>{coach}</h4>
                                                        </td>)        
                                                }        
                                                else if(current.ProgramName == "Croga | CrossFit Yoga"){
                                                    return(<td>
                                                        <h3 className='yoga'>CrossFit Yoga</h3>
                                                        <h4 className='time'>{time} - {endtime} </h4>
                                                        <h4 className='coach'>{coach}</h4>
                                                        </td>)        
                                                }        
                                                else{
                                                    return(<td>
                                                        <h3 className='comp'>COMPETITIVE</h3>
                                                        <h4 className='time'>{time} - {endtime} </h4>
                                                        <h4 className='coach'>{coach}</h4>
                                                        </td>)        
                                                }        
                                                break;
                                            }
                                            if(i === this.state.schedule[x].length - 1){
                                                return (<td></td>)
                                            }
                                            
                                        }   
                                    }
                                   
                                })}
                            </tr>)
                        })}
                    </thead>
                </table>
        </section>


        {/* Mobile Schedule */}
        <section id="mobileSchedule" className="py-5 my-3">
                <h3 className="my-2 teko mx-5">CLASS <br/>SCHEDULE</h3>
                <div className="decorative-line mx-5"></div>
                
                    <div className="listBox container py-3">
                        <ul id="mainList">
                        {["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"].map((x =>{
                                 return (<ul>
                                            <li className="teko day">{x}</li>
                                            {this.state.times.map((time,index) => {
                                                for(let i=0;i<this.state.schedule[x].length-1;i++){                                               
                                                    if(this.state.schedule[x][i].StartTime == this.state.timeList[index]){
                                                        let current = this.state.schedule[x][i];
                                                let endtime = "";
                                                endtime = new Date(current.EndDateTime)
                                                endtime = endtime.getHours() +"."+ endtime.getMinutes();
                                                if(endtime.length <= 4){
                                                    endtime += "0";
                                                }
                                            
                                                if(current.ProgramName == "CrossFit"){
                                                    return(<li>
                                                        <h3 className='crossfit'>CrossFit</h3>
                                                        <h4 className='time'>{time} - {endtime} </h4>
                                                        </li>)        
                                                }        
                                                else if(current.ProgramName == "OUTLAST"){
                                                    return(<li>
                                                        <h3 className='outlast'>OUTLAST</h3>
                                                        <h4 className='time'>{time} - {endtime} </h4>
                                                        </li>)        
                                                }               
                                                else if(current.ProgramName == "Croga | CrossFit Yoga"){
                                                    return(<li>
                                                        <h3 className='yoga'>CrossFit Yoga</h3>
                                                        <h4 className='time'>{time} - {endtime} </h4>
                                                        </li>)        
                                                }        
                                                else{
                                                    return(<li>
                                                        <h3 className='comp'>COMPETITIVE</h3>
                                                        <h4 className='time'>{time} - {endtime} </h4>
                                                        </li>)        
                                                }        
                                                break;
                                            
                                                    }                                                   
                                                }
                                            })}
                                        </ul>)
                            }))}
                        </ul> 
                    </div>
        </section>
        </>
        )}
    }
    }

// moment.suppressDeprecationWarnings = true; 

// let curr = new Date; // get current date
// let first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
// let firstday = new Date(curr.setDate(first));
// let dateString = firstday.getFullYear() + '-' + (firstday.getMonth() + 1) + '-' + parseInt(firstday.getDate());
// let now = moment(dateString);
// now = now.add(1,"days");
// let dateArray=[]

// console.log(dateArray);

// let crossfit = {
//     Sunday:[],
//     Monday:[],
//     Tuesday:[],
//     Wednesday:[],
//     Thursday:[],
//     Friday:[],
//     Saturday:[],

// }

// for(let i=0;i<7;i++){
//     dateArray.push(now.format('L'));
//     now = now.add(1,"days");

// }

// let counter = 0;
// function loadSchedule(apiKey, date, i) { 
//     let day = "";
//     switch(i){
//         case 0:
//             day = 'Monday';
//             break;
//         case 1:
//             day = 'Tuesday';
//             break;
//         case 2:
//             day = 'Wednesday';
//             break;
//         case 3:
//             day = 'Thursday';
//             break;
//         case 4:
//             day = 'Friday';
//             break;
//         case 5:
//             day = 'Saturday';
//             break;
//         case 6:
//             day = 'Sunday';
//             break;
        
//     }
//     $.ajax({ 
//         url: 'http://app.wodify.com/API/Classes_v1.aspx', 
//         data: {
//             apiKey: apiKey,
//             date: date, 
//             type: "json",
//         },  
//         dataType: "json",  
//         success: function(data){  
//             if(data) {
//                 data.RecordList.Class.forEach(x =>{
//                     switch(x.ProgramName){
                        
//                         case "CrossFit":
//                         case "Competitive Programing":
//                         case "Open Gym":
//                         case "OUTLAST":
//                             crossfit[day].push(x);
//                             break;
//                     }
//                 });
//             } 
//             counter++;
//             if(counter < 7) loadSchedule('vtaR6x7gTaDT21oOgt4LDsHbd', dateArray[counter], counter);
            
//             if(day == "Saturday"){
//                 buildCrossfit(crossfit);
//                 buildMobile(crossfit);    
//             } 
//         }  
//     });  
// }
// loadSchedule('vtaR6x7gTaDT21oOgt4LDsHbd', dateArray[counter], counter);


// console.log(crossfit);

// let crossfitTable = document.createElement('tbody');

// function buildCrossfit(obj){
//     let times = ["5.00","6.00","8.00","9.00","10.00","10.15","12.00","13.00","15.30","16.00","17.00","17.30","18.30","19.00","20.00"];
//     let timeCheck = ["05:00:00","06:00:00","08:00:00","09:00:00","10:00:00","10:15:00","12:00:00","13:00:00","15:30:00","16:00:00","17:00:00","17:30:00","18:30:00","19:00:00","20:00:00"]
//     for(let i=0;i<times.length;i++){
//         var tr = document.createElement("tr");
//         for(let j=0;j<8;j++){
//             let td = "";
//             let endtime = "";
//             let coach = "";
//                 if(j==0){
//                     td = document.createElement("td");
//                     td.innerHTML = "<h3 class='times'>"+ times[i] + "</h3>";
//                     tr.appendChild(td);
//                 }else if (j==1){
//                     let arr = obj.Monday;
//                     td = document.createElement("td");
//                     for(let z=0;z<15;z++){
//                         if(arr[z]){
//                             if(arr[z].StartTime == timeCheck[i]){
//                                 if(arr[z].Coaches.APICoach.Name == undefined){
//                                     coach = ""
//                                 }
//                                 else{
//                                     coach = arr[z].Coaches.APICoach.Name
//                                 }
//                                 endtime = new Date(arr[z].EndDateTime)
//                                 endtime = endtime.getHours() +"."+ endtime.getMinutes();
//                                 if(endtime.length <= 4){
//                                     endtime += "0";
//                                 }
//                                 if(arr[z].ProgramName == "CrossFit"){
//                                     td.innerHTML = "<h3 class='crossfit'>CrossFit</h3> <h4 class='time'>"+times[i]+" - "+ endtime + "</h4><h4 class='coach'>" + coach +"</h4>";
//                                 }
//                                 else if(arr[z].ProgramName == "OUTLAST"){
//                                     td.innerHTML = "<h3 class='outlast'>Outlast</h3> <h4 class='time'>"+times[i]+" - "+ endtime + "</h4><h4 class='coach'>" + coach +"</h4>";
//                                 }
//                                 else if(arr[z].ProgramName == "Open Gym"){
//                                     td.innerHTML = "<h3 class='opengym'>Open Gym</h3> <h4 class='time'>"+times[i]+" - "+ endtime + "</h4><h4 class='coach'>" + coach +"</h4>";
//                                 }
//                                 else{
//                                     td.innerHTML = "<h3 class='comp'>Competitive</h3> <h4 class='time'>"+times[i]+" - "+ endtime + "</h4><h4 class='coach'>" + coach +"</h4>";
//                                 }  
//                             }
//                         }
//                         tr.appendChild(td);
//                     }
                     
//                 }else if(j==2){
//                     let arr = obj.Tuesday;
//                     td = document.createElement("td");
//                     for(let z=0;z<15;z++){
//                         if(arr[z]){
//                             if(arr[z].StartTime == timeCheck[i]){
//                                 if(arr[z].Coaches.APICoach.Name == undefined){
//                                     coach = ""
//                                 }
//                                 else{
//                                     coach = arr[z].Coaches.APICoach.Name
//                                 }
//                                 endtime = new Date(arr[z].EndDateTime)
//                                 endtime = endtime.getHours() +"."+ endtime.getMinutes();
//                                 if(endtime.length <= 4){
//                                     endtime += "0";
//                                 }
//                                 if(arr[z].ProgramName == "CrossFit"){
//                                     td.innerHTML = "<h3 class='crossfit'>CrossFit</h3> <h4 class='time'>"+times[i]+" - "+ endtime + "</h4><h4 class='coach'>" + coach +"</h4>";
//                                 }
//                                 else if(arr[z].ProgramName == "OUTLAST"){
//                                     td.innerHTML = "<h3 class='outlast'>Outlast</h3> <h4 class='time'>"+times[i]+" - "+ endtime + "</h4><h4 class='coach'>" + coach +"</h4>";
//                                 }
//                                 else if(arr[z].ProgramName == "Open Gym"){
//                                     td.innerHTML = "<h3 class='opengym'>Open Gym</h3> <h4 class='time'>"+times[i]+" - "+ endtime + "</h4><h4 class='coach'>" + coach +"</h4>";
//                                 }
//                                 else{
//                                     td.innerHTML = "<h3 class='comp'>Competitive</h3> <h4 class='time'>"+times[i]+" - "+ endtime + "</h4><h4 class='coach'>" + coach +"</h4>";
//                                 }
                                
//                             }
//                         }
//                         tr.appendChild(td);
//                     }
                     
//                 }else if(j==3){
//                     let arr = obj.Wednesday;
//                     td = document.createElement("td");
//                     for(let z=0;z<15;z++){
//                         if(arr[z]){
//                             if(arr[z].StartTime == timeCheck[i]){
//                                 if(arr[z].Coaches.APICoach.Name == undefined){
//                                     coach = ""
//                                 }
//                                 else{
//                                     coach = arr[z].Coaches.APICoach.Name
//                                 }
//                                 endtime = new Date(arr[z].EndDateTime)
//                                 endtime = endtime.getHours() +"."+ endtime.getMinutes();
//                                 if(endtime.length <= 4){
//                                     endtime += "0";
//                                 }
//                                 if(arr[z].ProgramName == "CrossFit"){
//                                     td.innerHTML = "<h3 class='crossfit'>CrossFit</h3> <h4 class='time'>"+times[i]+" - "+ endtime + "</h4><h4 class='coach'>" + coach +"</h4>";
//                                 }
//                                 else if(arr[z].ProgramName == "OUTLAST"){
//                                     td.innerHTML = "<h3 class='outlast'>Outlast</h3> <h4 class='time'>"+times[i]+" - "+ endtime + "</h4><h4 class='coach'>" + coach +"</h4>";
//                                 }
//                                 else if(arr[z].ProgramName == "Open Gym"){
//                                     td.innerHTML = "<h3 class='opengym'>Open Gym</h3> <h4 class='time'>"+times[i]+" - "+ endtime + "</h4><h4 class='coach'>" + coach +"</h4>";
//                                 }
//                                 else{
//                                     td.innerHTML = "<h3 class='comp'>Competitive</h3> <h4 class='time'>"+times[i]+" - "+ endtime + "</h4><h4 class='coach'>" + coach +"</h4>";
//                                 }
                                
//                             }
//                         }
//                         tr.appendChild(td);
//                     }
                     
//                 }else if(j==4){
//                     let arr = obj.Thursday;
//                     td = document.createElement("td");
//                     for(let z=0;z<15;z++){
//                         if(arr[z]){
//                             if(arr[z].StartTime == timeCheck[i]){
//                                 if(arr[z].Coaches.APICoach == undefined || arr[z].Coaches.APICoach.Name == undefined){
//                                     coach = ""
//                                 }
//                                 else{
//                                     coach = arr[z].Coaches.APICoach.Name
//                                 }
//                                 endtime = new Date(arr[z].EndDateTime)
//                                 endtime = endtime.getHours() +"."+ endtime.getMinutes();
//                                 if(endtime.length <= 4){
//                                     endtime += "0";
//                                 }
//                                 if(arr[z].ProgramName == "CrossFit"){
//                                     td.innerHTML = "<h3 class='crossfit'>CrossFit</h3> <h4 class='time'>"+times[i]+" - "+ endtime + "</h4><h4 class='coach'>" + coach +"</h4>";
//                                 }
//                                 else if(arr[z].ProgramName == "OUTLAST"){
//                                     td.innerHTML = "<h3 class='outlast'>Outlast</h3> <h4 class='time'>"+times[i]+" - "+ endtime + "</h4><h4 class='coach'>" + coach +"</h4>";
//                                 }
//                                 else if(arr[z].ProgramName == "Open Gym"){
//                                     td.innerHTML = "<h3 class='opengym'>Open Gym</h3> <h4 class='time'>"+times[i]+" - "+ endtime + "</h4><h4 class='coach'>" + coach +"</h4>";
//                                 }
//                                 else{
//                                     td.innerHTML = "<h3 class='comp'>Competitive</h3> <h4 class='time'>"+times[i]+" - "+ endtime + "</h4><h4 class='coach'>" + coach +"</h4>";
//                                 }
                                
//                             }
//                         }
//                         tr.appendChild(td);
//                     }
                     
//                 }else if(j==5){
//                     let arr = obj.Friday;
//                     td = document.createElement("td");
//                     for(let z=0;z<15;z++){
//                         if(arr[z]){
//                             if(arr[z].StartTime == timeCheck[i]){
//                                 if(arr[z].Coaches.APICoach == undefined || arr[z].Coaches.APICoach.Name == undefined){
//                                     coach = ""
//                                 }
//                                 else{
//                                     coach = arr[z].Coaches.APICoach.Name
//                                 }
//                                 endtime = new Date(arr[z].EndDateTime)
//                                 endtime = endtime.getHours() +"."+ endtime.getMinutes();
//                                 if(endtime.length <= 4){
//                                     endtime += "0";
//                                 }
//                                 if(arr[z].ProgramName == "CrossFit"){
//                                     td.innerHTML = "<h3 class='crossfit'>CrossFit</h3> <h4 class='time'>"+times[i]+" - "+ endtime + "</h4><h4 class='coach'>" + coach +"</h4>";
//                                 }
//                                 else if(arr[z].ProgramName == "OUTLAST"){
//                                     td.innerHTML = "<h3 class='outlast'>Outlast</h3> <h4 class='time'>"+times[i]+" - "+ endtime + "</h4><h4 class='coach'>" + coach +"</h4>";
//                                 }
//                                 else if(arr[z].ProgramName == "Open Gym"){
//                                     td.innerHTML = "<h3 class='opengym'>Open Gym</h3> <h4 class='time'>"+times[i]+" - "+ endtime + "</h4><h4 class='coach'>" + coach +"</h4>";
//                                 }
//                                 else{
//                                     td.innerHTML = "<h3 class='comp'>Competitive</h3> <h4 class='time'>"+times[i]+" - "+ endtime + "</h4><h4 class='coach'>" + coach +"</h4>";
//                                 }
//                             }
//                         }
//                         tr.appendChild(td);
//                     }
                     
//                 }else if(j==6){
//                     let arr = obj.Saturday;
//                     td = document.createElement("td");
//                     for(let z=0;z<15;z++){
//                         if(arr[z]){
//                             if(arr[z].StartTime == timeCheck[i]){
//                                 if(arr[z].Coaches.APICoach == undefined || arr[z].Coaches.APICoach.Name == undefined){
//                                     coach = ""
//                                 }
//                                 else{
//                                     coach = arr[z].Coaches.APICoach.Name
//                                 }
//                                 endtime = new Date(arr[z].EndDateTime)
//                                 endtime = endtime.getHours() +"."+ endtime.getMinutes();
//                                 if(endtime.length <= 4){
//                                     endtime += "0";
//                                 }
//                                 if(arr[z].ProgramName == "CrossFit"){
//                                     td.innerHTML = "<h3 class='crossfit'>CrossFit</h3> <h4 class='time'>"+times[i]+" - "+ endtime + "</h4><h4 class='coach'>" + coach +"</h4>";
//                                 }
//                                 else if(arr[z].ProgramName == "OUTLAST"){
//                                     console.log("outlast")
//                                     td.innerHTML = "<h3 class='outlast'>Outlast</h3> <h4 class='time'>"+times[i]+" - "+ endtime + "</h4><h4 class='coach'>" + coach +"</h4>";
//                                 }
//                                 else if(arr[z].ProgramName == "Open Gym"){
//                                     td.innerHTML = "<h3 class='opengym'>Open Gym</h3> <h4 class='time'>"+times[i]+" - "+ endtime + "</h4><h4 class='coach'>" + coach +"</h4>";
//                                 }
//                                 else{
//                                     td.innerHTML = "<h3 class='comp'>Competitive</h3> <h4 class='time'>"+times[i]+" - "+ endtime + "</h4><h4 class='coach'>" + coach +"</h4>";
//                                 }
//                             }
//                         }
//                         tr.appendChild(td);
//                     }
                     
//                 }else if(j==7){
//                     let arr = obj.Sunday;
//                     td = document.createElement("td");
//                     for(let z=0;z<15;z++){
//                         if(arr[z]){
//                             if(arr[z].StartTime == timeCheck[i]){
//                                 if(arr[z].Coaches.APICoach == undefined || arr[z].Coaches.APICoach.Name == undefined){
//                                     coach = ""
//                                 }
//                                 else{
//                                     coach = arr[z].Coaches.APICoach.Name
//                                 }
//                                 endtime = new Date(arr[z].EndDateTime)
//                                 endtime = endtime.getHours() +"."+ endtime.getMinutes();
//                                 if(endtime.length <= 4){
//                                     endtime += "0";
//                                 }
//                                 if(arr[z].ProgramName == "CrossFit"){
//                                     td.innerHTML = "<h3 class='crossfit'>CrossFit</h3> <h4 class='time'>"+times[i]+" - "+ endtime + "</h4><h4 class='coach'>" + coach +"</h4>";
//                                 }
//                                 else if(arr[z].ProgramName == "OUTLAST"){
//                                     console.log("outlast")
//                                     td.innerHTML = "<h3 class='outlast'>Outlast</h3> <h4 class='time'>"+times[i]+" - "+ endtime + "</h4><h4 class='coach'>" + coach +"</h4>";
//                                 }
//                                 else if(arr[z].ProgramName == "Open Gym"){
//                                     td.innerHTML = "<h3 class='opengym'>Open Gym</h3> <h4 class='time'>"+times[i]+" - "+ endtime + "</h4><h4 class='coach'>" + coach +"</h4>";
//                                 }
//                                 else{
//                                     td.innerHTML = "<h3 class='comp'>Competitive</h3> <h4 class='time'>"+times[i]+" - "+ endtime + "</h4><h4 class='coach'>" + coach +"</h4>";
//                                 }
//                             }
//                         }
//                         tr.appendChild(td);
//                     }
                     
//                 }
                     
//         }
//         crossfitTable.append(tr);
//     }
//     $("table").append(crossfitTable);
// }

// function buildMobile(obj){
//     let times = ["5.00","6.00","8.00","9.00","10.00","10.15","12.00","13.00","15.30","16.00","17.00","17.30","18.30","19.00","20.00"];
//     let timeCheck = ["05:00:00","06:00:00","08:00:00","09:00:00","10:00:00","10:15:00","12:00:00","13:00:00","15:30:00","16:00:00","17:00:00","17:30:00","18:30:00","19:00:00","20:00:00"]
//     let endtime = "";
//     let start = "";

//     obj.Monday.forEach( (x) => {
//         endtime = new Date(x.EndDateTime)
//         endtime = endtime.getHours() +"."+ endtime.getMinutes();
//         if(endtime.length <= 4){
//             endtime += "0";
//         }
        
//         start = new Date(x.StartDateTime)
//         start = start.getHours() +"."+ start.getMinutes();
//         if(start.length <= 4){
//             start += "0";
//         }
        
//         if(x.ProgramName == "Competitive Programing"){
//             x.ProgramName = "Competitive"
//         }

//         $("#monday").append('<li class="classItem"><h5>'+ x.ProgramName +'</h5><h5 class="classTime">'+start+ ' - '+endtime+'</h5></li>');
//     });

//     obj.Tuesday.forEach( (x) => {
//         endtime = new Date(x.EndDateTime)
//         endtime = endtime.getHours() +"."+ endtime.getMinutes();
//         if(endtime.length <= 4){
//             endtime += "0";
//         }

//         start = new Date(x.StartDateTime)
//         start = start.getHours() +"."+ start.getMinutes();
//         if(start.length <= 4){
//             start += "0";
//         }

//         if(x.ProgramName == "Competitive Programing"){
//             x.ProgramName = "Competitive"
//         }

//         $("#tuesday").append('<li class="classItem"><h5>'+ x.ProgramName +'</h5><h5 class="classTime">'+start+ ' - '+endtime+'</h5></li>');
//     });

//     obj.Wednesday.forEach( (x) => {
//         endtime = new Date(x.EndDateTime)
//         endtime = endtime.getHours() +"."+ endtime.getMinutes();
//         if(endtime.length <= 4){
//             endtime += "0";
//         }

//         start = new Date(x.StartDateTime)
//         start = start.getHours() +"."+ start.getMinutes();
//         if(start.length <= 4){
//             start += "0";
//         }

//         if(x.ProgramName == "Competitive Programing"){
//             x.ProgramName = "Competitive"
//         }

//         $("#wednesday").append('<li class="classItem"><h5>'+ x.ProgramName +'</h5><h5 class="classTime">'+start+ ' - '+endtime+'</h5></li>');
//     });

//     obj.Thursday.forEach( (x) => {
//         endtime = new Date(x.EndDateTime)
//         endtime = endtime.getHours() +"."+ endtime.getMinutes();
//         if(endtime.length <= 4){
//             endtime += "0";
//         }

//         start = new Date(x.StartDateTime)
//         start = start.getHours() +"."+ start.getMinutes();
//         if(start.length <= 4){
//             start += "0";
//         }

//         if(x.ProgramName == "Competitive Programing"){
//             x.ProgramName = "Competitive"
//         }
        
//         $("#thursday").append('<li class="classItem"><h5>'+ x.ProgramName +'</h5><h5 class="classTime">'+start+ ' - '+endtime+'</h5></li>');
//     });

//     obj.Friday.forEach( (x) => {
//         endtime = new Date(x.EndDateTime)
//         endtime = endtime.getHours() +"."+ endtime.getMinutes();
//         if(endtime.length <= 4){
//             endtime += "0";
//         }

//         start = new Date(x.StartDateTime)
//         start = start.getHours() +"."+ start.getMinutes();
//         if(start.length <= 4){
//             start += "0";
//         }

//         if(x.ProgramName == "Competitive Programing"){
//             x.ProgramName = "Competitive"
//         }

//         $("#friday").append('<li class="classItem"><h5>'+ x.ProgramName +'</h5><h5 class="classTime">'+start+ ' - '+endtime+'</h5></li>');
//     });

//     obj.Saturday.forEach( (x) => {
//         endtime = new Date(x.EndDateTime)
//         endtime = endtime.getHours() +"."+ endtime.getMinutes();
//         if(endtime.length <= 4){
//             endtime += "0";
//         }

//         start = new Date(x.StartDateTime)
//         start = start.getHours() +"."+ start.getMinutes();
//         if(start.length <= 4){
//             start += "0";
//         }

//         if(x.ProgramName == "Competitive Programing"){
//             x.ProgramName = "Competitive"
//         }

//         $("#saturday").append('<li class="classItem"><h5>'+ x.ProgramName +'</h5><h5 class="classTime">'+start+ ' - '+endtime+'</h5></li>');
//     });

//     obj.Sunday.forEach( (x) => {
//         endtime = new Date(x.EndDateTime)
//         endtime = endtime.getHours() +"."+ endtime.getMinutes();
//         if(endtime.length <= 4){
//             endtime += "0";
//         }

//         start = new Date(x.StartDateTime)
//         start = start.getHours() +"."+ start.getMinutes();
//         if(start.length <= 4){
//             start += "0";
//         }

//         if(x.ProgramName == "Competitive Programing"){
//             x.ProgramName = "Competitive"
//         }

//         $("#sunday").append('<li class="classItem"><h5>'+ x.ProgramName +'</h5><h5 class="classTime">'+start+ ' - '+endtime+'</h5></li>');
//     });


// }
